import { useLang } from "../i18n";
import { Reveal, scrollToId } from "./Reveal";

export const Plan = () => {
  const { t } = useLang();
  const p = t.plan;

  return (
    <section id="plan" className="relative py-24 lg:py-32 border-t border-line overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(900px 500px at 10% 80%, rgba(168,214,127,0.09), transparent 60%)" }}
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <p className="mono-label">{p.eyebrow}</p>
          <h2 className="mt-4 font-display uppercase font-bold tracking-tight leading-[0.95] text-3xl sm:text-4xl lg:text-5xl max-w-3xl">
            {p.heading}
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {p.steps.map((st, i) => (
            <Reveal key={i} delay={i * 0.1} className="card-surface p-8 relative overflow-hidden" data-testid={`plan-step-${i}`}>
              <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-hadron-cyan to-transparent" />
              <span className="font-display font-bold text-6xl leading-none text-hadron-cyan/25">0{i + 1}</span>
              <h3 className="mt-5 font-display uppercase font-bold text-2xl text-txt">{st.t}</h3>
              <p className="mt-3 text-sm text-txt-2 leading-relaxed">{st.d}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-5 card-surface p-8 lg:p-10 flex flex-wrap items-center justify-between gap-8">
          <p className="max-w-2xl text-txt-2 leading-relaxed" data-testid="plan-success">{p.success}</p>
          <button
            data-testid="plan-cta"
            onClick={() => scrollToId("contact")}
            className="shrink-0 bg-hadron-cyan clip-frame px-8 py-4 font-mono2 text-xs uppercase tracking-[0.2em] text-ink font-medium hover:bg-hadron-green transition-colors"
          >
            {p.cta}
          </button>
        </Reveal>
      </div>
    </section>
  );
};
